import $ from 'jquery';
import scrollTo from './lib/scroll-to';

export default function({
    callback              = function(hash) {},
    duration              = 1000,
    disableScrollSelector = '.no-scroll',
    scrollOffset          = 0
} = {}) {
    // click event on all links with an anchor
    $('a[href*="#"]:not([href="#"])')
        .not(disableScrollSelector)
        .on('click', function(event) {
            // check if the link is on the same page (URL)
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                location.hostname == this.hostname
            ) {
                // get the target anchor
                var hash   = this.hash,
                    $hash  = $(hash),
                    target = $hash;

                target = target.length ?
                            target :
                            $('[name=' + this.hash.slice(1) + ']');

                // when we have a target
                if (target.length) {
                    event.preventDefault();

                    // trigger our callback
                    callback(hash);

                    // perform the scroll-to
                    scrollTo({
                        top:          target.offset().top + scrollOffset,
                        duration:     duration
                    });

                    // also jump screen readers to the wanted section
                    let tabIndex = target.attr('tabindex');
                    target.attr('tabindex', tabIndex !== undefined ? tabIndex : -1);
                    target.focus();
                }
            }
        });
}



// WEBPACK FOOTER //
// ./~/@spinnwerk/scroll-helper/scroll-anchor.js